export const LABELS = {
  futureChangeInExpenditure:
    "Are you aware of any future changes to the applicants' expenditure which may impact their ability to repay the mortgage?",
  changeInExpenditureDetail: "If yes, please give further details",
  foodDrinkGroceries: "Food, drink and groceries",
  clothingFootwearPersonal: "Clothing, footwear and personal effects",
  utilitiesOtherHousing: "Utilities & Other housing expenditure",
  furnishingsHouseholdMaintenance:
    "Furnishings, household equipment and maintenance",
  transportTravel: "Transport and travel",
  communication: "Communication",
  recreationRestaurantsHotels: "Recreation, restaurants and hotels",
  insurance: "Insurance",
  councilTax: "Council tax",
  cigarettesTobacco: "Cigarettes / tobacco",
  childcareSchoolFees: "Childcare and school fees",
  adultCare: "Adult care",
  maintenanceCsa: "Maintenance & CSA",
  mortgageEndowment: "Mortgage endowment / Repayment vehicle",
  health: "Health",
  other: "Other",
  applicantHasOutstandingCredit:
    "Does the applicant have any credit commitments?",
  creditProviders: {
    providerType: "Type",
    provider: "Credit Provider",
    balanceOutstanding: "Balance outstanding",
    settlementAmount: "Settlement Amount",
    monthlyPayment: "Monthly payment",
    consolidate: "Consolidate",
    isPartConsolidated: "Part settle",
  },
};
